export const fetchTranslations = async (hostname?: string) => {
  let url;
  if (hostname) {
    url = hostname.includes('local')
      ? '/__/translations'
      : `https://${hostname}/__/translations`;
  } else {
    url = '/__/translations';
  }

  await fetch(url)
    .then(response => response.json())
    .then(data => {
      window.__CLIENT_TRANSLATIONS__ = data;
      const event = new CustomEvent('translationsUpdated', {detail: data});
      document.dispatchEvent(event);
    });
};
